import * as React from "react"
import { useEffect, useState } from "react";
import { navigate } from "gatsby";
import CookiesMessage from "../CookiesMessage/CookiesMessage";
import "./styles.scss";
import { hasQueryParams, hasInfoQueryParams } from "../../lib/Misc";
import { LocaleLink, CurrentLocale } from "../../lib/IntlTools";
import Header from "../Header"
import Footer from "../Footer"
import Tabs from "../Tabs";

export default function Layout({
    isProductPassportView,
    children,
    hideCookies,
    extraMainClass,
    hideHeader,
    hideFooter,
    selectedDisplay,
    setSelectedDisplay,
    hideHeaderMenu,
    selectDisplayAction,
}) {
    const [usedPreload, setUsedPreload] = useState(false);
    const [showReward, setShowReward] = useState(false);
    const [windowClass, setWindowClass] = useState('');
    const [windowPath, setWindowPath] = useState('');

    const currentLang = CurrentLocale();

    const selectTab = (tab) => {
        navigate('/dwa');
        localStorage.setItem("selecteddisplay", tab);
    }

    // Hide if there are no query params
    useEffect(() => {
        setUsedPreload(parseInt(localStorage.getItem("preloaded") || 0));
        // setSelectedDisplay(localStorage.getItem("selecteddisplay") || null);

        if (typeof window !== "undefined") {
            setWindowPath(window.location.pathname);
            setWindowClass(window.location.pathname.split('/')[3] || window.location.pathname.split('/')[2] || window.location.pathname.split('/')[1]);

            if (window.location.pathname.split('/')[1] !== currentLang) {
                return (hasQueryParams() || hasInfoQueryParams())
                    ? navigate(LocaleLink(window.location.pathname + window.location.search))
                    : navigate(LocaleLink(window.location.pathname))
            }
        }
        setShowReward(hasQueryParams());
    }, [currentLang]);

    return (
        <div
            id="main"
            className={`main 
                ${windowClass !== '404' ? windowClass : 'problem'} 
                ${showReward ? 'claim' : ''}
                ${extraMainClass ? extraMainClass : ''}
             `}
        >
            {!hideHeader &&
                <Header
                    isProductPassportView={isProductPassportView}
                    selectedDisplay={selectedDisplay}
                    setSelectedDisplay={setSelectedDisplay}
                    hideHeaderMenu={hideHeaderMenu}
                />
            }

            {!hideHeader &&
                <Tabs tabs={['passport', 'gift']} selectedTab={selectedDisplay} setSelectedTab={selectDisplayAction || selectTab} />
            }

            <div className="content" id="content">
                {children}
            </div>

            {!hideFooter &&
                <Footer isProductPassportView={isProductPassportView} />
            }

            {!hideCookies && !isProductPassportView &&
                <CookiesMessage />
            }
        </div>
    )
}
